export default "__VITE_ASSET__DwQzEV3v__"